<script lang="ts">
    const { show }: { show: boolean | undefined } = $props();
</script>

{#if show}
    <div class="reptile-otto-up-wrapper">
        <oc-logo-v1 logo="otto-up" fill-parent data-testid="OttoUpLogo"></oc-logo-v1>
    </div>
{/if}

<style lang="scss">
    .reptile-otto-up-wrapper {
        display: flex;
        width: 52px;
    }
</style>
